module.exports = __webpack_public_path__ + "static/media/thumbs-up.b296ff53.svg";